import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DIMENSIONS } from 'utils/image/getPictureUrl';
import Box from 'components/Box';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import { TinyHorizontalCard } from 'components/ContentCards';
import { useDisclosure } from 'components/Disclosure';
function switchFirstTwoItems(items) {
  var _items = _toArray(items),
    first = _items[0],
    second = _items[1],
    rest = _items.slice(2);
  return [second, first].concat(_toConsumableArray(rest));
}
function RelatedPlaylists(_ref) {
  var _ref$playlists = _ref.playlists,
    playlists = _ref$playlists === void 0 ? [] : _ref$playlists,
    playlistId = _ref.playlistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDisclosure = useDisclosure(),
    isVisible = _useDisclosure.isVisible,
    toggle = _useDisclosure.toggle,
    buttonProps = _useDisclosure.buttonProps,
    contentProps = _useDisclosure.contentProps;

  // We don't want the parent playlist to be in the first spot,
  // so we switch its position with the second one if necessary
  var isFirstPlaylistParent = playlists[0].id === playlistId;
  var orderedPlaylists = isFirstPlaylistParent ? switchFirstTwoItems(playlists) : playlists;
  var playlistsToShow = isVisible ? orderedPlaylists : orderedPlaylists.slice(0, 1);
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs",
    px: "m",
    py: "s"
  }, /*#__PURE__*/React.createElement(Flex, {
    mt: "-xxs"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    as: "h2",
    fontSize: "s"
  }, t('asset_in_playlists_colon', {
    count: playlists.length
  })), playlists.length > 1 && /*#__PURE__*/React.createElement(Box, {
    mr: "-xs"
  }, /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
    onClick: toggle,
    variant: "transparent",
    size: "small"
  }), isVisible ? t('actions_show_less') : t('actions_show_more')))), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs",
    id: contentProps.id
  }, playlistsToShow.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      location = _ref2.location,
      pictureUrl = _ref2.pictureUrl;
    return /*#__PURE__*/React.createElement(TinyHorizontalCard, {
      key: id,
      title: title,
      subtitle: id === playlistId && t('you_are_here'),
      link: location,
      imageSource: pictureUrl ? "".concat(pictureUrl, "/").concat(DIMENSIONS.TINY_CARD) : '',
      icon: "playlist"
    });
  })));
}
export default RelatedPlaylists;